import React from 'react';
import VanMahotsav2023 from 'views/VanMahotsav2023';

const AccountGeneralPage = () => {
  return <VanMahotsav2023/>;
};

export default AccountGeneralPage;
